<template>
  <LoadingWrapper :state="status">
    <JournalSlide
      :feedback-topic="data.feedbackTopic"
      :member="dialog.coachee"
      :latest-value="data.analysis.latestValue"
      :progress="data.analysis.progress"
      :questions="data.analysis.questions"
      :scale="data.analysis.scale"
    />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { usePrepareJournalSlide } from '../composable/use-prepare-journal-slide'
  import JournalSlide from './JournalSlide.vue'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'
  import { injectStrict } from '@/core/utils/inject-strict'
  import { dialogKey } from '../composable/use-dialog-navigation'

  const route = useRoute()
  const feedbackTopicId = computed(() => route.params.feedbackTopicId as string)
  const { status, data } = usePrepareJournalSlide(feedbackTopicId)
  const dialog = injectStrict(dialogKey)
</script>
